import React from 'react';

import { useMemo, memo } from 'react';

const getCSSMask = (imageUrl: string | null | undefined) => {
  if (!imageUrl) return undefined;
  const cssUrl = `url("${imageUrl.replace(/"/g, `'`)}")`;
  return {maskImage: cssUrl, WebkitMaskImage: cssUrl};
}

export const IconButton = memo(({
  className = '',
  style,
  color,
  icon,
  label,
  onClick,
  children
}: IconButtonProps) => {

  const iconStyle = useMemo(() => {
    const css: React.CSSProperties | undefined = getCSSMask(icon);
    if (!color) return css;
    return {...css, backgroundColor: color};
  }, [color, icon]);

  return (
    <div className="deck-widget-button" style={style}>
      <button
        className={`deck-widget-icon-button ${className}`}
        type="button"
        onClick={onClick}
        title={label}
      >
        {children || <div className="deck-widget-icon" style={iconStyle} />}
      </button>
    </div>
  );
});

type IconButtonProps = {
  className?: string;
  icon?: string;
  label?: string;
  color?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children?: React.ReactNode;
};
